import { Controller } from "@hotwired/stimulus"

// Controls modal dialogs for configurable time sheet filter using native <dialog> element.
// The dialog is shown via showModal() which places it in the browser's top layer,
// above all other content regardless of z-index.
export default class extends Controller {
  connect() {
    // Handle native close event (triggered by Escape key or close() call)
    this.boundHandleClose = this.handleClose.bind(this)
    this.element.addEventListener("close", this.boundHandleClose)

    // Close when clicking the backdrop (the dialog element itself, not its children)
    this.boundHandleClick = this.handleClick.bind(this)
    this.element.addEventListener("click", this.boundHandleClick)
  }

  disconnect() {
    this.element.removeEventListener("close", this.boundHandleClose)
    this.element.removeEventListener("click", this.boundHandleClick)
  }

  // Open the dialog as modal
  open() {
    this.element.showModal()
    // Prevent body scroll when dialog is open
    document.body.style.overflow = "hidden"
  }

  // Close the dialog
  close() {
    this.element.close()
  }

  handleClose() {
    // Restore body scroll when dialog closes
    document.body.style.overflow = ""
  }

  handleClick(event) {
    // Close when clicking the backdrop (the dialog element itself)
    // This works because the dialog's ::backdrop is part of the dialog element
    if (event.target === this.element) {
      this.close()
    }
  }
}
